import { render } from "./FaLvFaGuiApiDataView.vue?vue&type=template&id=1685c07a&scoped=true"
import script from "./FaLvFaGuiApiDataView.vue?vue&type=script&lang=js"
export * from "./FaLvFaGuiApiDataView.vue?vue&type=script&lang=js"

import "./FaLvFaGuiApiDataView.vue?vue&type=style&index=0&id=1685c07a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1685c07a"]])

export default __exports__